const FOR = [
  "Entrepreneurs",
  "Nonprofit leaders",
  "Coaches & consultants",
  "Service providers",
  "Professionals",
  "Creatives",
  "Ministry leaders",
  "People with ideas in notebooks",
  "People tired of waiting on a developer",
  "Anyone who wants a practical AI skill",
];

const PHOTOS = [
  "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=400&q=85",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=400&q=85",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=85",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=85",
];

export default function WhoFor() {
  return (
    <section data-testid="who-for-section" className="relative py-24 lg:py-32 border-t border-[var(--line)]">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-5">Who This Is For</div>
            <h2 className="font-display text-[44px] sm:text-5xl lg:text-[64px] leading-[1.02] tracking-[-0.035em] text-ink mb-8">
              Builders. Leaders.{" "}
              <span className="font-serif-em italic text-brand font-light">Action-takers.</span>
            </h2>
            <p className="text-lg text-ink/70 mb-10 max-w-xl leading-relaxed">
              This is for the leader who&apos;s ready to{" "}
              <strong className="text-ink">stop talking about the idea</strong> and start building it.
            </p>

            <div className="flex flex-wrap gap-2 mb-10">
              {FOR.map((t) => (
                <span key={t} data-testid="for-tag" className="px-4 py-2 rounded-full text-sm bg-white border border-[var(--line)] text-ink hover:border-brand hover:text-brand transition-colors">
                  {t}
                </span>
              ))}
            </div>

            <div className="flex items-center gap-2">
              <div className="flex -space-x-3">
                {PHOTOS.map((p, i) => (
                  <div key={i} className="w-10 h-10 rounded-full overflow-hidden border-2 border-white shadow">
                    <img src={p} alt="" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <div className="text-sm text-ink/70 ml-2">
                <span className="text-ink font-medium">Real people.</span> Real builds. No tech background required.
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-10 lg:border-l lg:border-[var(--line)]">
            <div className="bg-bone rounded-3xl border border-[var(--line)] p-8 lg:p-10">
              <div className="font-mono-spec text-[11px] tracking-[0.22em] uppercase text-[#B85427] mb-4 font-medium">Not For</div>
              <h3 className="font-display text-2xl sm:text-3xl tracking-[-0.025em] text-ink mb-5 leading-tight">
                People who want to sit back and do nothing.
              </h3>
              <p className="text-ink/70 leading-relaxed mb-6">
                This is for{" "}
                <strong className="text-ink">builders, dreamers, problem-solvers, and action-takers</strong>{" "}
                who are ready to learn what&apos;s possible and start moving.
              </p>
              <p className="font-serif-em italic text-brand text-xl leading-snug font-light">
                If that&apos;s not you &mdash; move on with our blessing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
